/// <reference path="../types.d.ts" />
import { createReducer } from '@reduxjs/toolkit';
import { Login } from '../actions/action-types';
import InitialState from '../reducers/initial-state';
import { syncActions, logoutApp, handleContext, toggleEmailConfirmationModal, authenticate, loginViaSSO, postAuthNavigate, getGlobalConfig } from '../actions/login.action';
import { inProgress } from '../actions/common';
import { selectContext } from '../actions/contexts.action';
import { logout } from '../actions/ui';
import { jumpContext } from '../actions/contexts.action';
import { IS_PRODUCTION } from '../core/environment';
import { formErrors } from '../stubs/form-errors';
const reducer = createReducer(InitialState.login, (builder)=>{
    builder.addCase(logout.type, ()=>({
            ...InitialState.login
        })).addCase(jumpContext.pending.type, ()=>({
            ...InitialState.login
        })).addCase(inProgress, (state)=>({
            ...state,
            submitting: true,
            status: Login.IN_PROGRESS,
            error: false
        })).addCase(syncActions.loginInitial, (state)=>({
            ...state,
            status: Login.INITIAL,
            error: false,
            formErrors: formErrors.noErrors
        })).addCase(syncActions.loginFailed, (state, action)=>({
            ...state,
            submitting: false,
            status: Login.FAILED,
            error: true,
            message: typeof action.payload === 'string' && action.payload.length > 0 ? action.payload : action.payload?.message || undefined
        })).addCase(logoutApp.fulfilled, ()=>({
            ...InitialState.login
        })).addCase(syncActions.displayContexts, (state, action)=>{
        return {
            ...state,
            submitting: false,
            contexts: action.payload
        };
    }).addCase(selectContext.fulfilled.type, (state, action)=>{
        const context = action.payload;
        return {
            ...state,
            context
        };
    }).addCase(syncActions.loginSuccess, (state, action)=>{
        const token = action.payload;
        if (!IS_PRODUCTION) {
            // @ts-ignore
            window.sessionStorage.setItem('authToken', token.token);
        }
        return {
            ...state,
            submitting: false,
            status: Login.SUCCESS,
            error: false,
            auth: token
        };
    }).addCase(syncActions.changePassword, (state)=>{
        return {
            ...state,
            forcePasswordChange: true
        };
    }).addCase(syncActions.changePasswordInitial, (state)=>{
        return {
            ...state,
            error: false,
            submitting: true,
            formErrors: formErrors.noErrors
        };
    }).addCase(syncActions.changePasswordSuccess, (state)=>{
        return {
            ...state,
            error: false,
            submitting: false,
            forcePasswordChange: false
        };
    }).addCase(syncActions.changePasswordFailed, (state, action)=>{
        return {
            ...state,
            error: true,
            submitting: false,
            forcePasswordChange: true,
            message: undefined,
            formErrors: action.payload ?? formErrors.noErrors
        };
    }).addCase(toggleEmailConfirmationModal, (state, action)=>{
        return {
            ...state,
            emailConfirmationModalOpen: action.payload
        };
    }).addCase(authenticate.pending, (state, action)=>{
        return {
            ...state,
            username: action.meta.arg.username
        };
    }).addCase(handleContext.fulfilled, (state)=>{
        return {
            ...state,
            forcePasswordChange: undefined,
            loading: false
        };
    }).addCase(loginViaSSO.pending, (state)=>{
        return {
            ...state,
            loading: true
        };
    }).addCase(postAuthNavigate.fulfilled, (state)=>{
        return {
            ...state,
            loading: false
        };
    }).addCase(getGlobalConfig.fulfilled, (state, action)=>{
        return {
            ...state,
            config: action.payload
        };
    });
});
export default reducer;
